import {
    DeepRequired,
    FieldErrors,
    FieldErrorsImpl,
    FieldName,
    FieldValues,
    UnPackAsyncDefaultValues,
} from "react-hook-form";
import { ErrorMessage, FieldValuesFromFieldErrors } from "@hookform/error-message";

export const ErrorMessageDisplay = (props: { message: string }) => {
    const { message } = props;

    return (
        <div>
            <small className="text-danger">{message}</small>
        </div>
    );
};

export function CustomErrorMessage<T extends FieldValues>(props: {
    errors: FieldErrors<T>;
    name: FieldName<FieldValuesFromFieldErrors<Partial<FieldErrorsImpl<DeepRequired<UnPackAsyncDefaultValues<T>>>>>>;
}) {
    const { name, errors } = props;

    return (
        <ErrorMessage
            errors={errors}
            name={name}
            render={({ message }: { message: string }) => <ErrorMessageDisplay message={message} />}
        />
    );
}
